import { Autocomplete } from '@material-ui/lab';
import { TextInput } from '@room-match/shared-ui-components';
import { FormikProps } from 'formik';
import React from 'react';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import CompCardButton from '../CompCardButton';
import { useStyles } from '../SizeCard.styles';
interface Props {
  form: FormikProps<ITalentUpdatePayload>;
  filterOptions: any;
  kidsLengthOptions: any[];
  kidClothing: any[];
  infants: any[];
  filteredKidShoeOptions: any[];
  compCardAdd?: (arg0: { key: string; value: string }) => void;
  compCardRemove?: (arg0: { key: string }) => void;
  requiredOnly?: boolean;
  requiredFields?: string[];
}

const Babies: React.FC<Props> = ({
  kidClothing,
  infants,
  filteredKidShoeOptions,
  form,
  filterOptions,
  kidsLengthOptions,
  compCardAdd,
  compCardRemove,
  requiredOnly,
  requiredFields,
}) => {
  const classes = useStyles();

  const handleStatChange =
    (key: string) =>
    (
      _: any,
      newValue: string | null,
      reason: 'create-option' | 'select-option' | 'remove-option' | 'blur' | 'clear',
    ) => {
      if (compCardRemove && reason === 'clear') {
        compCardRemove({ key });
      }
      form.setFieldValue(`statistics.${key}`, newValue);
    };

  const isRequired = (field: string) => requiredFields?.includes(field) && !requiredOnly;

  return (
    <React.Fragment>
      {(!requiredOnly || requiredFields?.includes('length')) && (
        <div>
          <CompCardButton
            attributes={{
              label: 'Length',
              key: 'length',
            }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.length !== '' && form.values.statistics?.length !== null}
          />
          <Autocomplete
            filterOptions={filterOptions}
            onChange={handleStatChange('length')}
            value={form.values.statistics?.length}
            options={kidsLengthOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select'}
                errorMessage={isRequired('length') && !form.values.statistics?.length ? 'Length is required' : ''}
              />
            )}
          />
        </div>
      )}{' '}
      {(!requiredOnly || requiredFields?.includes('kidsClothing')) && (
        <div>
          <CompCardButton
            attributes={{
              label: 'Kids Clothing',
              key: 'kidsClothing',
            }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.kidsClothing !== '' && form.values.statistics?.kidsClothing !== null}
          />
          <Autocomplete
            filterOptions={filterOptions}
            onChange={handleStatChange('kidsClothing')}
            value={form.values.statistics?.kidsClothing}
            options={kidClothing.map((k) => k.value)}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select'}
                errorMessage={
                  isRequired('kidsClothing') && !form.values.statistics?.kidsClothing ? 'Kids clothing is required' : ''
                }
              />
            )}
          />
        </div>
      )}
      {(!requiredOnly || requiredFields?.includes('kid_shoe_size')) && (
        <div>
          <CompCardButton
            attributes={{
              label: 'Kids Shoe Size',
              key: 'kid_shoe_size',
            }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.kid_shoe_size !== '' && form.values.statistics?.kid_shoe_size !== null}
          />
          <Autocomplete
            id="SC-kidsShoeSize"
            filterOptions={filterOptions}
            onChange={handleStatChange('kid_shoe_size')}
            value={form.values.statistics?.kid_shoe_size}
            options={filteredKidShoeOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select'}
                errorMessage={
                  isRequired('kid_shoe_size') && !form.values.statistics?.kid_shoe_size
                    ? 'Kids shoe size is required'
                    : ''
                }
              />
            )}
          />
        </div>
      )}
      {(!requiredOnly || requiredFields?.includes('infants')) && (
        <div>
          <CompCardButton
            attributes={{
              label: 'Infants',
              key: 'infants',
            }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.infants !== '' && form.values.statistics?.infants !== null}
          />
          <Autocomplete
            filterOptions={filterOptions}
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'infants' });
              }
              handleStatChange('infants')(e, newValue, reason);
            }}
            value={form.values.statistics?.infants}
            options={infants.map((i) => i.value)}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select'}
              />
            )}
          />
        </div>
      )}{' '}
    </React.Fragment>
  );
};

export default Babies;
